@if(order() && position()){
<div class="p-4">

  <p-button (click)="printPage()" class="no-print">Stampa Documento</p-button>
</div>
<div class="printable-area bg-white spike-card m-4">
  <div class="grid grid-cols-12 border border-black">
    <div class="col-span-4 border-r border-black p-2 flex flex-col items-center justify-center">
      <div class="flex flex-col items-center">
        <span class="text-blue-500 font-bold text-lg leading-tight uppercase">meccanica</span>
        <span class="text-2xl font-black tracking-tighter uppercase leading-none">FAGGIO <span class="text-[10px] lowercase font-normal italic">srl</span></span>
        <span class="text-lg font-bold uppercase tracking-widest">Ciclo di Lavoro</span>

      </div>
    </div>
    <div class="col-span-8 flex flex-col">
      <div class="grid grid-cols-2 border-b border-black h-1/2">
        <div class="p-1 border-r border-black">
          <span class="block text-[8px] font-bold">DATA:</span>
          {{ position()!.production?.sendDate | date: 'dd/MM/yyyy' }}
        </div>
        <div class="p-1">
          <span class="block text-[8px] font-bold">REFERENTE TECNICO:</span>
          {{ organizationStore.getEmployee(position()!.production?.reference!)()?.shortDescription  }}
        </div>
      </div>
    </div>
  </div>

  <div class="grid grid-cols-12 border-l border-r border-b border-black">
    <div class="col-span-4 border-r border-black">
      <div class="p-1 border-b border-black">
        <span class="font-bold">NS. COMMESSA:</span> {{ order()!.code }}
      </div>
      <div class="p-1 border-b border-black">
        <span class="font-bold">CLIENTE:</span> {{ organizationStore.getClient(order()!.clientId!)()?.shortDescription }}
      </div>
      <div class="grid grid-cols-2 border-b border-black">
        <div class="p-1 border-r border-black"><span class="font-bold">DISEGNO:</span> {{position()!.code}}</div>
        <div class="p-1"><span class="font-bold">REV. :</span> 1</div>
      </div>
      <div class="p-1">
        <span class="font-bold">DESCRIZIONE:</span> {{ position()!.shortDescription }}
      </div>
    </div>
    <div class="col-span-8 flex flex-col">
      <div class="p-1 border-b border-black h-1/2">
        <span class="font-bold block">MATERIALE:</span>
        <div class="text-[9px]">
          @for(material of position()!.production?.materials; track $index){
            <span>{{ organizationStore.getEquipment(material.equipmentId)()?.shortDescription }} </span>
          }
        </div>
      </div>
      <div class="p-1 h-1/2">
        <span class="font-bold">DISEGNI SIMILI :</span>
      </div>
    </div>
  </div>

  <div class="grid grid-cols-12 border-l border-r border-b border-black bg-gray-200">
    <div class="col-span-12 p-0.5 px-2 font-bold text-[9px]">CONTROLLO MATERIALE :</div>
  </div>

  <div class="border-l border-r border-b border-black">
    <div class="grid grid-cols-24 text-center font-bold text-[8px] items-stretch border-b border-black uppercase">
      <div class="col-span-1 border-r border-black p-1">OP</div>
      <div class="col-span-7 border-r border-black p-1">Descrizione Operazioni</div>
      <div class="col-span-2 border-r border-black p-1">Macchina</div>
      <div class="col-span-2 border-r border-black p-1">Tempo Lav. Previsto</div>
      <div class="col-span-2 border-r border-black p-1">Tempo Attr. Previsto</div>
      <div class="col-span-2 border-r border-black p-1">N.Pezzi da Collaudare</div>
      <div class="col-span-2 border-r border-black p-1">Tempo Lav. Effettivo</div>
      <div class="col-span-2 border-r border-black p-1">Tempo Attr. Effettivo</div>
      <div class="col-span-2 border-r border-black p-1">Operatore</div>
      <div class="col-span-2 p-1">Codice/Info</div>
    </div>

    <div class="divide-y divide-black">
      @for (op of position()!.production?.operations; track $index) {
      <div class="grid grid-cols-24 min-h-[35px] text-[9px]">
        <div class="col-span-1 border-r border-black flex items-center justify-center font-bold">{{ $index + 1 }}</div>
        <div class="col-span-7 border-r border-black p-1 items-center italic">
          <div><b>{{  organizationStore.getOperation(op.operationTypeId!)()?.shortDescription  }}</b></div>
          <div>{{ organizationStore.getOperation(op.operationTypeId!)()?.description  }}</div>
          </div>
        <div class="col-span-2 border-r border-black p-1 flex items-center justify-center text-center">
            {{ organizationStore.getMachine(op.machineId!)()?.shortDescription }}
        </div>
        <div class="col-span-2 border-r border-black flex items-center justify-center">{{ op.workingTime }} min.</div>
        <div class="col-span-2 border-r border-black flex items-center justify-center">{{ op.equipmentTime }} min.</div>
        <div class="col-span-2 border-r border-black flex items-center justify-center">N. {{ op.quantity }} </div>
        <div class="col-span-2 border-r border-black flex items-center justify-center">{{op.finalWorkingTime ? op.finalWorkingTime +' min.' : ''}} </div>
        <div class="col-span-2 border-r border-black flex items-center justify-center">{{op.finalEquipmentTime ? op.finalEquipmentTime +' min.' : ''}} </div>
        <div class="col-span-2 border-r border-black p-1 flex items-center justify-center text-center">
            {{ organizationStore.getEmployee(op.employeeId!)()?.shortDescription }}
        </div>
        <div class="col-span-2 p-1 italic text-[7px]">
          {{op.description}}
        </div>
      </div>
      }
      
      @for (i of [].constructor(9 - (position()!.production?.operations?.length || 0)); track $index) {
        <div class="grid grid-cols-24 min-h-[35px] border-t border-black">
            <div class="col-span-1 border-r "></div>
            <div class="col-span-7 border-r"></div>
            <div class="col-span-2 border-r"></div>
            <div class="col-span-2 border-r k"></div>
            <div class="col-span-2 border-r border-black"></div>
            <div class="col-span-2 border-r border-black"></div>
            <div class="col-span-2 border-r border-black"></div>
            <div class="col-span-2 border-r border-black"></div>
            <div class="col-span-2 border-r border-black"></div>
            <div class="col-span-2"></div>
        </div>
      }
    </div>
  </div>

  <div class="grid grid-cols-12 border-l border-r border-b border-black min-h-[80px]">
    <div class="col-span-10 p-1">
      <span class="font-bold text-[9px] uppercase">Annotazioni:</span>
      <p class="text-[10px] mt-1">{{ position()!.production?.description }}</p>
    </div>
    <div class="col-span-2 border-l border-black flex flex-col">
      <div class="bg-gray-200 border-b border-black text-center font-bold text-[8px] p-0.5">COLLAUDO</div>
      <div class="flex-grow"></div>
    </div>
  </div>
</div> 
} @else {
  Nessuna posizione da stampare
}